

































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component
export default class AuthModal extends Vue {}
